import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";
import { classes } from "istanbul-lib-coverage";

const ConfirmationModal = (props) => {
  const { title, label, content, modalOpen, handleModalClose, submit } = props;
  const { t } = useTranslation();
  return (
    <div>
      <Dialog
        open={modalOpen}
        onClose={() => handleModalClose()}
        aria-labelledby={label}
        maxWidth="md"
        classes={{ paper: classes.dialog }}
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{content}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleModalClose()}>{t("Components.Modals.Cancel")}</Button>
          <Button onClick={() => submit()}>{t("Components.Modals.Confirm")}</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

ConfirmationModal.propTypes = {
  modalOpen: PropTypes.bool.isRequired,
  handleModalClose: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  label: PropTypes.string,
  content: PropTypes.string.isRequired,
};

ConfirmationModal.defaultProps = {
  label: "confirmation-modal",
};

export default ConfirmationModal;
